// extracted by mini-css-extract-plugin
module.exports = {"Logo":"Logo_Logo__3a6cJ","logoImg":"Logo_logoImg__3OFT0"};